"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "francolise": {
    "858a8284": [{
      "hkey": "9d60fc4e",
      "slug": "sant-andrea-del-pizzone-ciamprisco",
      "name": "Sant'Andrea del Pizzone-Ciamprisco",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea-pizzone-ciamprisco": [{
      "hkey": "9d60fc4e",
      "slug": "sant-andrea-del-pizzone-ciamprisco",
      "name": "Sant'Andrea del Pizzone-Ciamprisco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a8908244": [{
      "hkey": "9d60fc4e",
      "slug": "sant-andrea-del-pizzone-ciamprisco",
      "name": "Sant'Andrea del Pizzone-Ciamprisco",
      "primary": true,
      "skipSearch": false
    }],
    "ciamprisco": [{
      "hkey": "9d60fc4e",
      "slug": "sant-andrea-del-pizzone-ciamprisco",
      "name": "Sant'Andrea del Pizzone-Ciamprisco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "416fb72f": [{
      "hkey": "9d60fc4e",
      "slug": "sant-andrea-del-pizzone-ciamprisco",
      "name": "Sant'Andrea del Pizzone-Ciamprisco",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea-del-pizzone": [{
      "hkey": "9d60fc4e",
      "slug": "sant-andrea-del-pizzone-ciamprisco",
      "name": "Sant'Andrea del Pizzone-Ciamprisco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;